import React from 'react';
import styled from 'styled-components';
import { Tooltip } from '@/components/atoms';
import { IColorMarkerCmp } from './IColorMarkerCmp';

interface IStyledProps {
  bgcolor: string[];
  size: string;
  bgimageUrl?: string | null;
  active?: boolean;
}

const LabelledCircle = styled.div`
  display: flex;
  align-items: center;
`;

const MarkerWrapper = styled.div`
  padding: 2px 0;
`;
const Marker = styled.div<IStyledProps>`
  width: 10px;
  height: 14px;
  border: solid;
  border-width: ${props => (props.size === 'small' ? '1px' : '1px')};
  border-color: ${props => props.theme.paletteDefault.primary.main};
  margin: 0 8px;
  background-color: ${props => props.bgcolor[0]};
  background-image: ${props =>
    props.bgimageUrl && props.bgcolor.length === 1
      ? `url(${props.bgimageUrl})`
      : ''};
`;

const Label = styled.div`
  font-size: 14px;
`;

const ColorMarker: React.FC<IColorMarkerCmp> = ({
  label,
  colorLabel,
  bgcolor,
  bgimageUrl,
  showLabel,
  onClickColor,
  active,
  size,
}) => {
  let bg_color =
    bgcolor !== undefined && bgcolor.length > 0 ? bgcolor : ['#ffffff'];

  const onClickHandler = (e: any) => {
    if (onClickColor) {
      e.preventDefault();
      if (colorLabel) {
        onClickColor(colorLabel);
      }
    }
  };
  const marker = (
    <Marker
      active={active}
      bgcolor={bg_color}
      bgimageUrl={bgimageUrl}
      onClick={onClickHandler}
      size={size}
    />
  );
  let circleWrapItem;
  if (!showLabel) {
    circleWrapItem = (
      <Tooltip title={label} placement="bottom">
        {marker}
      </Tooltip>
    );
  } else {
    circleWrapItem = (
      <LabelledCircle>
        <MarkerWrapper> {marker}</MarkerWrapper>
        <Label>{label}</Label>
      </LabelledCircle>
    );
  }

  return circleWrapItem;
};

export default ColorMarker;
